import script from "./OngoingLive.vue?vue&type=script&setup=true&lang=js"
export * from "./OngoingLive.vue?vue&type=script&setup=true&lang=js"

import "./OngoingLive.vue?vue&type=style&index=0&id=444b13b6&scoped=true&lang=css"

import exportComponent from "/home/tamo/projects/wedio/frontend/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-444b13b6"]])

export default __exports__